import React from 'react';

import './WindowControlButtons.scss';
import { ToolbarIcon } from '@instinet-analytics/semantic-ui-components';

export function WindowControlButtons({
    isMaximised,
    onClickClose,
    onClickMinimize,
    onClickMaximizeRestore,
}: {
    isMaximised: boolean;
    onClickClose: () => void;
    onClickMinimize: () => void;
    onClickMaximizeRestore: () => void;
}) {
    return (
        <div className="WindowControlButtons">
            <ToolbarIcon name="window minimize" onClick={onClickMinimize} />

            {isMaximised && (
                <ToolbarIcon
                    name="window restore"
                    onClick={onClickMaximizeRestore}
                />
            )}
            {!isMaximised && (
                <ToolbarIcon
                    name="window maximize"
                    onClick={onClickMaximizeRestore}
                />
            )}

            <ToolbarIcon name="close" onClick={onClickClose} />
        </div>
    );
}
